import 'css-chunk:src/lib/LoadSpinner/LoadSpinner.scss';export default {
  "LoadSpinner": "_LoadSpinner_1yuvr_1"
};